import { PaginationState, Updater } from '@tanstack/react-table';

import { callOrReturn } from '@adsk/alloy-react-helpers';

export const usePagination = (
  recordCount = 0,
  pagination: PaginationState,
  onPaginationChange?: (pagination: PaginationState) => void,
) => {
  return {
    paginationState: { pagination },
    paginationOptions: {
      pageCount: Math.ceil(recordCount / pagination.pageSize),
      manualPagination: true,
      onPaginationChange: (updaterOrValue: Updater<PaginationState>) => {
        const newState = callOrReturn<Updater<PaginationState>>(
          updaterOrValue,
          pagination,
        );
        onPaginationChange?.(newState);
        return newState;
      },
    },
  };
};
